/**
 * 汎用スライダーナビゲーション機能
 * ファイル名: slider-navigation.js
 * 矢印ボタンとインジケーターの制御（複数スライダー対応）
 */

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    // 全てのスライダーセクションを取得
    const sliderSections = document.querySelectorAll('.p-top__section.-new-arrival');
    
    sliderSections.forEach(function(section) {
      const slider = section.querySelector('.o-itemList.-fes-slider');
      if (!slider) return;
      
      initSliderNavigation(section, slider);
    });
  });

  /**
   * スライダーナビゲーションの初期化
   */
  function initSliderNavigation(section, slider) {
    const prevButton = section.querySelector('.slider-arrow-prev');
    const nextButton = section.querySelector('.slider-arrow-next');
    
    if (!prevButton || !nextButton) return;

    // デバイス幅に応じたスクロール量を計算
    function getScrollAmount() {
      const width = window.innerWidth;
      
      if (width >= 1025) {
        // PC: 4列
        return slider.offsetWidth / 4;
      } else if (width >= 768) {
        // タブレット: 3列
        return slider.offsetWidth / 3;
      } else {
        // スマホ: 2列
        return slider.offsetWidth / 2;
      }
    }

    /**
     * 左矢印クリック
     */
    prevButton.addEventListener('click', function() {
      slider.scrollBy({
        left: -getScrollAmount(),
        behavior: 'smooth'
      });
    });

    /**
     * 右矢印クリック
     */
    nextButton.addEventListener('click', function() {
      slider.scrollBy({
        left: getScrollAmount(),
        behavior: 'smooth'
      });
    });

    /**
     * スクロール位置に応じて矢印のdisabled状態を更新
     */
    function updateArrows() {
      const scrollLeft = slider.scrollLeft;
      const maxScroll = slider.scrollWidth - slider.offsetWidth;

      // 左端にいるとき
      if (scrollLeft <= 1) {
        prevButton.classList.add('disabled');
      } else {
        prevButton.classList.remove('disabled');
      }

      // 右端にいるとき
      if (scrollLeft >= maxScroll - 1) {
        nextButton.classList.add('disabled');
      } else {
        nextButton.classList.remove('disabled');
      }
    }

    // 初期状態の矢印を更新
    updateArrows();

    // スクロール時に矢印を更新
    slider.addEventListener('scroll', updateArrows);

    // ウィンドウリサイズ時に再計算
    window.addEventListener('resize', updateArrows);

    /**
     * インジケーター機能（スマホ用）
     */
    initIndicators(section, slider);
  }

  /**
   * インジケーターの初期化（スマホ用）
   */
  function initIndicators(section, slider) {
    const indicatorsContainer = section.querySelector('.slider-indicators');
    
    if (!slider || !indicatorsContainer) return;
    
    const currentWidth = window.innerWidth;
    if (currentWidth >= 768) return;

    // 空でないli要素のみカウント（m-itemCardを持つもの）
    const items = Array.from(slider.querySelectorAll('.o-itemList__item')).filter(function(item) {
      return item.querySelector('.m-itemCard') !== null;
    });
    
    const totalPages = Math.ceil(items.length / 2); // 2列表示
    
    // ページが1つしかない場合はインジケーター不要
    if (totalPages <= 1) {
      indicatorsContainer.style.display = 'none';
      return;
    }

    // インジケーターのドットを生成
    indicatorsContainer.innerHTML = '';
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement('div');
      dot.classList.add('indicator-dot');
      if (i === 0) dot.classList.add('active');
      
      dot.addEventListener('click', function() {
        const scrollAmount = slider.offsetWidth * i;
        slider.scrollTo({
          left: scrollAmount,
          behavior: 'smooth'
        });
      });
      
      indicatorsContainer.appendChild(dot);
    }

    // スクロール時にアクティブなドットを更新
    slider.addEventListener('scroll', function() {
      const scrollLeft = slider.scrollLeft;
      const currentPage = Math.round(scrollLeft / slider.offsetWidth);
      
      section.querySelectorAll('.indicator-dot').forEach(function(dot, index) {
        if (index === currentPage) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    });
  }

})();